/**
 * Determines the minimum search length based on the language.
 * Chinese (zh) allows shorter search terms since characters have more meaning.
 * 
 * @param language - The current language code
 * @returns Minimum number of characters required for search
 */
export const getMinSearchLength = (language: string): number => {
  return language === "zh" ? 1 : 3;
};

/**
 * Checks if a search query meets the minimum length requirement for the given language.
 * 
 * @param query - The search query string
 * @param language - The current language code
 * @returns True if the query meets the minimum length requirement
 */
export const isValidSearchLength = (query: string, language: string): boolean => {
  return query.length >= getMinSearchLength(language);
}; 